import FairListProduct from './FairListProduct.jsx';

export {
  FairListProduct
}


// WEBPACK FOOTER //
// ./components/fair/sub-view/list/index.js